import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Grid } from '@mui/material';
import { Fragment } from 'react';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiTableCell from "@material-ui/core/TableCell";


export default function WorkflowInfoPrint(props: any) {

    let data = props.data;
    const TableCell = withStyles({
        root: {
            borderBottom: "0 !important",
            borderTop: "0  !important",
        }

    })(MuiTableCell);
    return (
        <>
            <Grid item xs={12} style={{ marginTop: "1.5vh" }}>
                <div
                    className="cardTableBorder"
                    style={{ minHeight: "30vh" }}
                >
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table" >
                            <TableHead
                                className="rowTHead"
                                style={{ paddingBottom: "10px" }}
                            >
                                <TableRow className="borderRight borderLeft">
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="right"
                                        style={{ width: "10vh", minWidth: "10vh" }}
                                    >
                                        ردیف
                                    </TableCell>
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        کاربر
                                    </TableCell>

                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        تاریخ عملیات
                                    </TableCell>
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        گردش کار
                                    </TableCell>
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        نوع عملیات
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* {rows.map((row) => (
                                    <Row key={row.name} row={row} />
                                ))} */}
                                {data?.map((row: any, rowIndex: any) => {
                                    return (
                                        <>
                                            <Fragment>
                                                <TableRow


                                                    className={`${rowIndex % 2 == 0
                                                        ? "rowTBodyE  borderRight borderLeft"
                                                        : "rowTBodyO  borderRight borderLeft"
                                                        } `}
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={row.value}
                                                >

                                                    <TableCell className="textFont12">
                                                        {
                                                            rowIndex +
                                                            1}
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.userTitle}</span>

                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.actionDatePersian}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.workflowTypeTitle}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className={`${row.workflowStepType == "Forward" ? "SuccessDefaultFont textFont12" : " DangerDefaultFont textFont12"}`}
                                                        align="right"
                                                    >
                                                        <span>{row.actionTitle}</span>
                                                    </TableCell>
                                                </TableRow>
                                                {row.userData?.map((item: any, index: number) => (
                                                    <TableRow className='borderRight borderLeft' >
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                            <Collapse in={true} timeout="auto" unmountOnExit >
                                                                <Box sx={{ paddingTop: '2vh', paddingBottom: '2vh' }}>
                                                                    <Grid container style={{ backgroundColor: "#EDEFEF", paddingRight: '1vh', paddingLeft: '1vh', paddingTop: '2vh', paddingBottom: '2vh' }}>
                                                                        <div className='fontBlueColor textFont14' style={{ paddingRight: '2vh' }}>{item.key}</div>:<div className='colorRed textFont14 fontWeight' >{item.value}</div>
                                                                    </Grid>
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                                )}

                                            </Fragment >




                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Grid >
        </>
    );
}